import { ENDPOINTS } from 'config/endpoints';
import { useQuery } from '@tanstack/react-query';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import Error from 'crono-fe-common/types/error';

export default function useCheckPaymentCustomer(enabled = true) {
  return useQuery<
    Response<{
      customerId: string | null;
      email: string | null;
      firstName: string | null;
      lastName: string | null;
      priceId: string | null;
    } | null>,
    Error
  >({
    queryKey: [ENDPOINTS.subscription.paymentCustomer],
    queryFn: () => {
      const request: Request = {
        url: ENDPOINTS.subscription.paymentCustomer,
        config: {
          method: 'get',
        },
      };
      return client(request);
    },
    enabled,
  });
}
